module.exports = __webpack_public_path__ + "static/media/banner-hot-deals-tablet.9b796d1a.jpg";